import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=fc2f69cc&"
import script from "./PageBuilder.vue?vue&type=script&lang=ts&"
export * from "./PageBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports